module.exports = __webpack_public_path__ + "6fcd4a9b4080fde4479b27932d3be94b.svg";